import React, { CSSProperties } from "react";

import { TrendingUp } from "lucide-react";

export const CognitiveSecurityScore = () => {
    return (
        <div className='card card--md card--radius-md card--hover-shadow w-full dashboard__mcsa__cognitive_security_score'>
            <div className='d-flex justify-content-between align-items-center mb-xl'>
                <div>
                    <p className='text-lg text-semibold'>Cognitive Security Score</p>
                    <p className='text-sm color--txt-muted'>Overall organizational resilience</p>
                </div>
                <div className='d-flex align-items-center gap-xs'>
                    <TrendingUp className='w-lg h-lg color--success' />
                    <p className='text-sm color--success'>+2.7</p>
                </div>
            </div>
            <div className="dashboard__mcsa__cognitive_security_score__progress_ring">
                <svg>
                    <circle className="dashboard__mcsa__cognitive_security_score__progress_ring__track" />
                    <circle
                        className="dashboard__mcsa__cognitive_security_score__progress_ring__progress"
                        style={{ '--progress': 67.68 } as CSSProperties}
                    />
                </svg>
                <div className='dashboard__mcsa__cognitive_security_score__progress_ring__label'>
                    <p className='text-4xl text-bold'>64.67<span className='text-2xl color--gray-500'>%</span></p>
                    <p className='text-sm color--gray-500 text-medium'>Good</p>
                </div>
            </div>
            <div className='dashboard__mcsa__cognitive_security_score__progress_details'>
                <div className='w-full p-lg bg--black-t5 br-sm'>
                    <p className='text-sm color--txt-muted mb-xs'>Dept. Average</p>
                    <p className='text-xl text-bold'>64.67%</p>
                </div>
                <div className='w-full p-lg bg--black-t5 br-sm'>
                    <p className='text-sm color--txt-muted mb-xs'>7-Day Change</p>
                    <p className='text-xl text-bold'>+2.7%</p>
                </div>
            </div>
        </div>
    );
};